/*
 * @Author: Mike Cottingham 
 * @Date: 2018-04-24 21:39:43 
 * @Last Modified by: Mike Cottingham
 * @Last Modified time: 2019-04-09 14:54:53
 */

import {moduleName} from "./constants"
import * as _ from 'lodash'

export const getInvoice = (state) => (state[moduleName])
export const getExportedInvoices = (state) => _.orderBy((state['exportedInvoices']), 'invoiceNumber')